const renderSettingsVideo = () => {
    return <div />;
};
export default renderSettingsVideo;
